import React from 'react';
import { Icons } from '@ohif/ui-next';
import { DiagnosisState } from '../../utils';
import { ButtonContentProps } from './types';

/**
 * Three icons, not develop's five (plan D-5). `Cancel` and `AlertOutline` belonged
 * exclusively to the `rejectedDC` / `rejectedC` keys, which §4.1 drops as unreachable —
 * `state` is always an uppercase DiagnosisState, so those keys and the `accepted` one
 * could never be looked up.
 *
 * No Icons.addIcon: every icon here already exists in @ohif/ui-next. Brand iconography
 * is parent §5.2's M5 work.
 *
 * REQUIRES_ASSESSMENT keeps develop's StatusSuccess even though a success tick reads
 * oddly for "your input is needed". D1 is same-observable-behaviour, and an icon is
 * observable.
 */
const CONTENT: Record<DiagnosisState, { Icon: React.ElementType; label: string }> = {
  [DiagnosisState.IDLE]: { Icon: Icons.ToolMagnify, label: 'Diagnose' },
  [DiagnosisState.PROCESSING]: { Icon: Icons.ToolMagnify, label: 'Processing...' },
  [DiagnosisState.REQUIRES_ASSESSMENT]: {
    Icon: Icons.StatusSuccess,
    label: 'Requires Assessment',
  },
  [DiagnosisState.ASSESSED]: { Icon: Icons.StatusSuccess, label: 'Assessed' },
  [DiagnosisState.REVOCABLE]: { Icon: Icons.ToolReset, label: 'Revoke' },
};

export default function ButtonContent({ state }: ButtonContentProps) {
  const { Icon, label } = CONTENT[state];

  return (
    <>
      <Icon
        aria-hidden="true"
        className="h-5 w-5"
      />
      {/*
        The span is rendered on every state, never conditionally, because a live region
        has to be in the DOM before its content changes for the change to be announced.
        aria-atomic, so "Processing..." is read whole rather than as a diff.
      */}
      <span
        aria-live="polite"
        aria-atomic="true"
        className="align-middle"
      >
        {label}
      </span>
    </>
  );
}
